import React from 'react';
import styled from 'styled-components';
import RoundedCheckboxSvg from '../assets/rounded-checkbox.svg';

const RoundedCheckbox = styled(RoundedCheckboxSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  g {
      path:last-child {
      fill: ${props => props.fill || props.theme.colors.downriver.medium};
      }
  }
  /* margin: ${props => props.margin}; */
  /* cursor: pointer; */
`;

export default RoundedCheckbox;
